import TagsListModel from '../tags/TagsListModel'
import * as Utils from '../../modules/Utils'

export default (data) => ({
  key: data.id,
  firstName: data.firstName,
  lastName: data.lastName,
  id: data.id,
  internalId: data.internalId,
  email: data.email,
  name: data.firstName + ' ' + data.lastName,
  title: data.firstName + ' ' + data.lastName,
  tags: new TagsListModel(data.tags),
  birthDate: data.birthDate,
  formattedBirthDate: data.birthDate ? Utils.dateToString(data.birthDate) : ''
})



// WEBPACK FOOTER //
// ./src/api/employees/EmployeeModel.js